import { VersionType } from '@wix/ambassador-ctp-gradual-rollout-v1-app-config/types';

export enum ReleaseVersionType {
  MINOR = VersionType.MINOR,
  MAJOR = VersionType.MAJOR,
}
